import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import Alerta from "../modal/Alerta";
import AuthContext from '../../context/authentication/authContext';
import loader from "../../img/ajax-loader.gif";

const RecoverPassword = () => {

    //  Extraer valores de context
    const authContext = useContext(AuthContext);
    const { msg, authenticated, recuperarUsuario } = authContext;

    useEffect(() => {
        if ( msg ) {
            setMessage(msg.msg);
        }
        // eslint-disable-next-line
    }, [msg, authenticated ]);

    const [ user, setUser ] = useState({
        email: ''
    });

    const { email } = user;

    const [ showAlerta, setShowAlerta] = useState(false);
    const [ message, setMessage ] = useState("");

    const onChange = e => {
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }

    const onSubmit = e => {
        e.preventDefault();

        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        // Validar que el email sea correcto
        if ( !emailRegex.test(email) ) {
            setMessage("El email está mal escrito");
            setShowAlerta(true);
            document.getElementById("email").focus()
            return;
        }

        setMessage(<label><img src={loader} alt="loader" /> Procesando...</label>);
        setShowAlerta(true);

        recuperarUsuario({email});
    }

    return (
        <div className="global-container">
            { showAlerta && <Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={message} /> }
            <div className="login-form">
                <div className="card">
                    <div className="card-body">
                        <h3 className="card-title text-center">Recuperar Contraseña</h3>
                        <div className="card-text">
                            {/* {
                                enviado && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">Fue enviado un enlace a su correo electrónico para reestablecer su contraseña</div>
                                )
                            } */}
                            <form onSubmit={onSubmit}>
                                <div className="form-group">
                                    <label htmlFor="">Correo electrónico</label>
                                    <input 
                                        type="email"
                                        className="form-control form-control-sm"
                                        name="email"
                                        placeholder="Correo electrónico"
                                        value={email}
                                        onChange={onChange}
                                        required />
                                </div>

                                <button type="submit" className="btn btn-primary btn-block">Enviar enlace</button>
                                <div className="sign-up">
                                    <Link to={'/'} className="enlace-cuenta">
                                        Iniciar sesión
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default RecoverPassword